var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "", "text-xs-center": "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-center": "", "align-center": "", row: "" } },
        _vm._l(_vm.serviceBookProduct, function(item) {
          return _c(
            "v-flex",
            { key: item.id, attrs: { xs3: "" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "primary--text",
                  class: [item.featured ? "turquoise py-4" : "greyLighter"],
                  staticStyle: { "border-radius": "12px" },
                  attrs: { flat: "" }
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "", "justify-center": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "font-weight-bold",
                              staticStyle: { "font-size": "24px" }
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "", "justify-center": "" } },
                        [
                          _c("v-flex", [_vm._v(_vm._s(item.description))]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "font-weight-bold pa-0",
                              staticStyle: { "font-size": "48px" }
                            },
                            [_vm._v(_vm._s(item.price) + "€")]
                          ),
                          _vm._v(" "),
                          item.annual_cost
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "pa-0",
                                  staticStyle: { "font-size": "14px" }
                                },
                                [
                                  _vm._v(
                                    "Soit " + _vm._s(item.annual_cost) + "€/An"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "font-weight-bold text-capitalize",
                                  attrs: {
                                    round: "",
                                    color: item.featured
                                      ? "secondary"
                                      : "primary",
                                    dark: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.navigateTo(item.url)
                                    }
                                  }
                                },
                                [_vm._v("Acheter")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8f75678", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8f75678","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/home/components/modal-buy-servicebook/template.html
// module id = null
// module chunks = 